var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var WidgetTypeError = /** @class */ (function (_super) {
    __extends(WidgetTypeError, _super);
    function WidgetTypeError() {
        return _super.call(this, "WidgetTypeError: Unknown Widget Type") || this;
    }
    return WidgetTypeError;
}(Error));
export { WidgetTypeError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2lkZ2V0VHlwZUVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2ZlYXR1cmVzL21vbml0b3JpbmcvZXJyb3JzL1dpZGdldFR5cGVFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTtJQUFxQyxtQ0FBSztJQUN4QztlQUNFLGtCQUFNLHNDQUFzQyxDQUFDO0lBQy9DLENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUFKRCxDQUFxQyxLQUFLLEdBSXpDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFdpZGdldFR5cGVFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgY29uc3RydWN0b3IoKSB7XG4gICAgc3VwZXIoXCJXaWRnZXRUeXBlRXJyb3I6IFVua25vd24gV2lkZ2V0IFR5cGVcIik7XG4gIH1cbn1cbiJdfQ==